
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo_2.png";
import msLogo from "../../assets/ms-symbollockup_signin_light.svg";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
    const { t } = useTranslation()
    const { instance, inProgress } = useMsal();
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [logging, setLogging] = useState(false);

    const account = instance.getActiveAccount();

    const handleMsalLogin = async () => {
        setError(false);
        try {
            setLogging(true);
            const response = await instance.loginPopup(loginRequest);
            instance.setActiveAccount(response.account);
        } catch (e) {
            setError(true);
            console.error(e)
        } finally {
            setLogging(false);
        }
    };

    useEffect(() => {
        if (account) {
            navigate("/grupos");
        }
    }, [account]);

    return (
        <body>
            <main className="relative prose w-screen h-screen flex justify-center items-center max-w-none bg-zinc-300 bg-login bg-cover">
                <div className="flex flex-col gap-4 drop-shadow bg-white p-6 rounded-md items-center">
                    <img src={logo} alt="logo" className="h-8 m-0" />
                    {logging ? 
                    <Loader2 className="animate-spin" />
                    : <button type="button" onClick={handleMsalLogin}>
                        <img src={msLogo} alt="logo" className="m-0 p-0" />
                    </button>}
                    {error && <p className="text-xs text-red-600 m-0">Ocorreu um erro ao tentar fazer o login</p>}
                </div>
                <span className="absolute right-2 bottom-2 m-0 text-xs opacity-50">{process.env.REACT_APP_VERSION}</span>
            </main>
        </body>
    )
}